<template>
  <div>
    <!-- Detalles del viaje existentes -->
    <div class="row g-4 mb-4">
      <!-- Tarjeta 1 -->
      <div class="col-12 col-md-6 col-xl-3">
        <div class="card h-100">
          <div class="card-body d-flex align-items-center">
            <div class="rounded-circle-custom bg-zebra-light p-3 me-3">
              <i class="fas fa-clock text-zebra"></i>
            </div>
            <div>
              <div class="text-muted small">Tipo de viaje</div>
              <div class="fw-bold">{{ cotizar.nombreCategoria }}</div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Tarjeta 2 -->
      <div class="col-12 col-md-6 col-xl-3">
        <div class="card h-100">
          <div class="card-body d-flex align-items-center">
            <div class="rounded-circle-custom bg-zebra-light p-3 me-3">
              <i class="fas fa-map-marker-alt text-zebra"></i>
            </div>
            <div>
              <div class="text-muted small">Origen / Destino</div>
              <div class="fw-bold">
                - {{ cotizar.origenNombre }}<br>
                - {{ cotizar.destinoNombre }}
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Tarjeta 3 -->
      <div class="col-12 col-md-6 col-xl-3">
        <div class="card h-100">
          <div class="card-body d-flex align-items-center">
            <div class="rounded-circle-custom bg-zebra-light p-3 me-3">
              <i class="fas fa-calendar-alt text-zebra"></i>
            </div>
            <div>
              <div class="text-muted small">Fechas de salida / regreso</div>
              <div class="fw-bold">
                {{ formatFecha(cotizar.fi) }} - {{ formatFecha(cotizar.ff) }}
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Tarjeta 4 -->
      <div class="col-12 col-md-6 col-xl-3">
        <div class="card h-100">
          <div class="card-body d-flex align-items-center">
            <div class="rounded-circle-custom bg-zebra-light p-3 me-3">
              <i class="fas fa-users text-zebra"></i>
            </div>
            <div>
              <div class="text-muted small">No. de pasajeros</div>
              <div class="fw-bold">{{ cotizar.cantidadPasajeros }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { es } from 'date-fns/locale';
import moment from 'moment';

export default {
  props: {
    cotizar: {
      type: Object,
      required: true
    },
    merchants: {
      type: Object,
      default: null
    }
  },
  
  data() {
    return {
      esLocale: es,
      termsAccepted: false,
      formData: {
        customer_email: '',
        customer_data: {
          legal_id: '',
          full_name: '',
          phone_number: '',
          legal_id_type: 'CC'
        },
        payment_method: {
          type: 'BANCOLOMBIA_TRANSFER',
          user_type: 'PERSON',
          payment_description: 'Pago a Tienda Wompi',
          sanbox_status: 'APROVED'
        }
      },
      reference: 'pedido-' + Date.now()
    };
  },

  methods: {
    formatFecha(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },

    calculateAmount() {
      // Calcula el monto en centavos basado en los datos de cotizar
      return Math.round((this.cotizar.plan?.pvp * this.cotizar.noDias * this.cotizar.trm) * 100);
    },

    formatAmount(cents) {
      const amount = cents / 100;
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP'
      }).format(amount);
    },

    async processPayment() {
      try {
        const paymentData = {
          acceptance_token: this.merchants?.presigned_acceptance?.token,
          amount_in_cents: this.calculateAmount(),
          currency: 'COP',
          customer_email: this.formData.customer_email,
          reference: this.reference,
          customer_data: this.formData.customer_data,
          payment_method: this.formData.payment_method
        };

        // Emitir evento con los datos del pago
        this.$emit('process-payment', paymentData);
      } catch (error) {
        console.error('Error al procesar el pago:', error);
      }
    }
  }
};
</script>

<style scoped>
.card {
    border: none;
}

/* .card-header.bg-zebra {
    background-color: #5c677d; 
}

.card-title {
    font-size: 1.5rem;
    font-weight: bold;
}

.text-muted {
    font-size: 0.95rem;
}

.font-weight-bold {
    font-size: 1rem;
} */

/* Podemos mantener estilos mínimos ya que Bootstrap hace la mayor parte */
/* .card {
  transition: transform 0.2s;
} */

.rounded-circle-custom {
  border-radius: 9999px;
  width: 56px;
}
.card:hover {
  transform: translateY(-5px);
}

/* Si necesitas ajustar el color del icono al de tu diseño */
.text-secondary {
  color: #5c677d !important;
}

/* .btn-success {
    background-color: #28a745;
    border: none;
    transition: background-color 0.3s ease;
}

.btn-success:hover {
    background-color: #218838;
} */

.text-zebra {
  color: #20c997;
  text-decoration: none;
}

.text-zebra:hover {
  text-decoration: underline;
}

.form-check-input:checked {
  background-color: #20c997;
  border-color: #20c997;
}

.btn-zebra {
  background-color: #20c997;
  color: white;
}

.btn-zebra:hover {
  background-color: #17a2b8;
}

.btn-zebra:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.form-label {
  font-weight: 500;
}

.card {
  border: none;
  box-shadow: 0 0 15px rgba(0,0,0,0.1);
}
</style>